import { useMemo } from "react";
import { getAddressText, toStarRating } from "@b2bportal/core-utilities";
import { htmlDecode } from "@hopper-b2b/utilities";
import type { HotelInfoSectionProps } from "./HotelInfoSection";

export const useHotelInfoSection = ({ hotelData }: HotelInfoSectionProps) => {
  const reviews = hotelData.tripAdvisorReviews;

  return useMemo(() => {
    //Out of 5 stars
    const overallRating =
      reviews?.overallScore != null && reviews.overallScore > 0
        ? reviews.overallScore * 5
        : undefined;
    return {
      context: {
        overallRating,
        starRating: toStarRating(hotelData.starRating),
      },
      text: {
        hotelName: htmlDecode(hotelData.name) ?? hotelData.name,
        address: getAddressText(hotelData.address),
        reviewCount:
          reviews?.reviewsCount != null
            ? `(${reviews.reviewsCount})`
            : undefined,
      },
    };
  }, [hotelData, reviews]);
};
